import { render } from "./LeaveTypeColorSwatchCell.vue?vue&type=template&id=e8157eae&scoped=true"
import script from "./LeaveTypeColorSwatchCell.vue?vue&type=script&lang=js"
export * from "./LeaveTypeColorSwatchCell.vue?vue&type=script&lang=js"

import "./LeaveTypeColorSwatchCell.vue?vue&type=style&index=0&id=e8157eae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8157eae"]])

export default __exports__